
import {BrowserRouter, Route, Routes, useNavigate} from 'react-router-dom';
import * as React from "react";
import VideosTable from "./components/videosTable/videosTable";
import EditModal from "./components/editModal/editModal";
import Login from "./components/login/login";

function App() {
  return(
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/videos' element={<VideosTable />} />
          <Route path='/edit' element={<EditModal />} />
        </Routes>
    </BrowserRouter>
    </div>
);
}

export default App;
